import { render } from "./Checkbox.vue?vue&type=template&id=fc011b04"
import script from "./Checkbox.vue?vue&type=script&lang=js"
export * from "./Checkbox.vue?vue&type=script&lang=js"

import "./Checkbox.vue?vue&type=style&index=0&id=fc011b04&lang=css"

import exportComponent from "/Users/danielseguin/Documents/Websites/ootp-calculator/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__